import { createContext } from 'react';
import { BillingCycle as BillingCycles } from '~/types/models';

type BillingCycleContextProps = {
  billingCycle: BillingCycles;
  setBillingCycle: (cycle: BillingCycles) => void;
};

export default createContext<BillingCycleContextProps>({
  billingCycle: BillingCycles.Yearly,
  setBillingCycle: () => undefined,
});
